<template>
    <div class="home">
        <div class="content-wrapper">
            <img alt="Baddtories logo" src="../assets/logo.png" />
            <HelloWorld msg="Welcome to Baddstories" />
        </div>
    </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'

export default {
    name: 'home',
    components: {
        HelloWorld
    }
}
</script>

<style lang="scss" scoped>
.home {
    display: grid;
    height: 80vh;

    .content-wrapper {
        align-self: center;
        justify-self: center;
    }
}
</style>
